import React from 'react';
import Reports from '../components/Reports';

const ReportsPage = ({ projects, employees, milestones }) => {
  return <Reports projects={projects} employees={employees} milestones={milestones} />;
};

export default ReportsPage;
